import {useAuctionSettings} from "hooks/StateHooks"
import React from "react"

class LegalText extends React.Component {
  render() {
    return (
      <div className="w-full flex flex-col mt-6 md:mt-0">
        <pre className="font-sans h-full w-full p-1 whitespace-pre-wrap text-xs">
          {useAuctionSettings().legalNotice}
        </pre>
      </div>
    )
  }
}

export default LegalText
